export const FULL_WIDTH_TALL_BUTTON = "w-full h-13";

export const PRESS_FEEDBACK =
  "transition-all duration-150 active:scale-[0.98]";

export const OUTLINE_PRESSABLE_BUTTON =
  `${PRESS_FEEDBACK} active:bg-accent/80`;

export const GREEN_ACTION_BUTTON_ENABLED =
  "bg-[#8CEE7B] text-black relative transition-all duration-150 hover:bg-[#74e763] active:bg-[#61d650] active:scale-[0.98]";

export const GREEN_ACTION_BUTTON_ENABLED_WITH_SHADOW =
  `${GREEN_ACTION_BUTTON_ENABLED} shadow-sm`;

export const GREEN_ACTION_BUTTON_DISABLED =
  "bg-[#ACE1BD] text-black relative cursor-not-allowed";